export default __webpack_public_path__ + "static/media/1000.7b941f80.png";